const cleanNestedObject = (obj) => {
  if (typeof obj !== "object" || obj === null) return obj; // Ensure it's an object

  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      obj[key] = cleanNestedObject(obj[key]); // Recursively clean nested objects
      if (Object.keys(obj[key]).length === 0) {
        delete obj[key]; // Remove empty objects
      }
    }

    if (
      obj[key] === undefined || // Remove undefined values
      obj[key] === "" || // Remove empty strings
      (Array.isArray(obj[key]) && obj[key].length === 0) // Remove empty arrays
    ) {
      delete obj[key];
    }
  });

  return obj;
};

export default cleanNestedObject;



// WEBPACK FOOTER //
// ./src/utils/cleanObject.js